/* eslint-disable @typescript-eslint/no-redeclare */
export type DataExtractorOrderDirection =
  (typeof DataExtractorOrderDirection)[keyof typeof DataExtractorOrderDirection];

export const DataExtractorOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
